export default __webpack_public_path__ + "static/media/shark2.89739a97.jpg";